module.exports = __webpack_public_path__ + "static/media/noun_Playing Cards_139188.6b454874.svg";